import { Outlet } from "react-router";

export default function LoggedOutOnlyLayout() {
  return <Outlet />;
}
